import { render } from "./GraphPage.vue?vue&type=template&id=428a0852&scoped=true"
import script from "./GraphPage.vue?vue&type=script&lang=js"
export * from "./GraphPage.vue?vue&type=script&lang=js"

import "./GraphPage.vue?vue&type=style&index=0&id=428a0852&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428a0852"]])

export default __exports__